module.exports = __webpack_public_path__ + "static/img/12-1.dcf011c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/12-1.jpg
// module id = mH03
// module chunks = 1